<div class="w-full h-full pb-20 bg-gray-50 font-prompt mx-auto overflow-auto">
  <!-- ========== Header ดำ (แบรนด์) ========== -->
  <div
    class="w-full bg-(--header-background) px-4 py-2.5 flex items-center justify-between sticky top-0 z-30"
  >
    <div class="flex items-center gap-2.5">
      <div
        class="w-10 h-10 rounded-full overflow-hidden border border-white/20 flex items-center justify-center bg-neutral-700 relative"
        (click)="goToNavigate('/profile')"
      >
        <img
          *ngIf="pictureUrl; else fallbackAvatar"
          [src]="pictureUrl"
          alt="Avatar"
          class="w-full h-full object-cover"
        />
        <ng-template #fallbackAvatar>
          <img
            src="/icons/person-home.png"
            alt="User"
            class="w-5 h-5 object-contain opacity-70 invert"
          />
        </ng-template>
        <span
          class="absolute right-0 bottom-0 w-3 h-3 rounded-full bg-[#06c755] border-2 border-(--header-background)"
        ></span>
      </div>
      <img
        src="/images/element-24.png"
        alt="City Parking"
        class="h-8 object-contain"
      />
    </div>
    <div
      class="flex items-center bg-white/10 p-0.5 rounded-full text-[11px] font-bold text-white/65"
    >
      <button
        type="button"
        (click)="changeLang('TH')"
        class="px-2.5 py-1 rounded-full transition-all duration-300 border-0 cursor-pointer"
        [ngClass]="
          currentLang === 'TH'
            ? 'bg-[var(--main-color)] text-slate-800 shadow-sm'
            : 'bg-transparent text-white/65'
        "
      >
        TH
      </button>
      <button
        type="button"
        (click)="changeLang('EN')"
        class="px-2.5 py-1 rounded-full transition-all duration-300 border-0 cursor-pointer"
        [ngClass]="
          currentLang === 'EN'
            ? 'bg-[var(--main-color)] text-slate-800 shadow-sm'
            : 'bg-transparent text-white/65'
        "
      >
        EN
      </button>
    </div>
  </div>

  <!-- ========== Hero band ดำ + ทักทาย ========== -->
  <div
    class="bg-(--header-background) rounded-b-[2.5rem] px-4 pt-1 pb-5 shadow-[0_12px_28px_rgba(58,58,58,0.28)] relative overflow-hidden"
  >
    <div
      class="absolute -right-9 -top-5 w-[120px] h-[120px] rounded-full bg-[rgba(255,197,39,0.12)] pointer-events-none"
    ></div>
    <div class="relative z-10 text-left">
      <span class="text-[11px] font-medium text-white/70">{{
        currentLang === "TH" ? "สวัสดี" : "Hello"
      }}</span>
      <h2
        class="text-[15px] font-extrabold text-white tracking-wide truncate max-w-[260px] mt-0.5"
      >
        {{ displayName }}
      </h2>
    </div>
  </div>

  <div class="px-4 -mt-1">
    <!-- ========== Zone 1B: Active Parking (0–N) ========== -->
    <div class="mt-3" *ngIf="activeSessions.length > 0">
      <div class="flex items-center justify-between mb-2.5">
        <h3
          class="text-xs font-extrabold text-gray-500 uppercase tracking-wide"
        >
          {{ currentLang === "TH" ? "รถที่กำลังจอด" : "Active parking" }}
          ({{ activeSessions.length }})
        </h3>
        <button
          type="button"
          (click)="goToActiveParking()"
          class="text-xs font-bold text-amber-600 hover:text-amber-700 bg-transparent border-none cursor-pointer"
        >
          {{ currentLang === "TH" ? "ดูทั้งหมด" : "View all" }}
        </button>
      </div>
      <div
        class="session-row custom-scrollbar flex gap-2.5 overflow-x-auto snap-x snap-mandatory pb-1 -mx-4 px-4"
      >
        <div
          *ngFor="let session of activeSessions; trackBy: trackBySession"
          class="session-card flex-shrink-0 w-[260px] snap-start rounded-2xl p-3.5 text-white relative overflow-hidden"
        >
          <div class="relative z-10">
            <span
              class="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[10px] font-bold bg-emerald-500/20 text-emerald-300 mb-2"
            >
              <span
                class="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse"
              ></span>
              {{ currentLang === "TH" ? "กำลังจอด" : "Parking" }}
            </span>
            <div class="text-[15px] font-extrabold tracking-wide">
              {{ session.entryLicense }}
            </div>
            <div class="text-[11px] text-white/70 mt-0.5 mb-2.5 truncate">
              {{ session.siteName }}
            </div>
            <div class="flex gap-2 mb-3">
              <div class="flex-1 bg-white/10 rounded-xl px-2.5 py-2">
                <span class="block text-[9px] text-white/60 font-medium">{{
                  currentLang === "TH" ? "เวลา" : "Duration"
                }}</span>
                <strong class="text-sm font-extrabold"
                  >{{ hour(session.totalTime) }}h
                  {{ session.totalTime % 60 }}m</strong
                >
              </div>
              <div
                class="flex-1 bg-white/10 rounded-xl px-2.5 py-2 relative overflow-hidden"
                [class.fee-pending]="!session.isFeeReady"
              >
                <span class="block text-[9px] text-white/60 font-medium">{{
                  currentLang === "TH" ? "ค่าจอด" : "Fee"
                }}</span>
                <strong
                  *ngIf="session.isFeeReady"
                  class="text-sm font-extrabold text-(--main-color)"
                  >฿ {{ session.totalPay | number: "1.0-0" }}</strong
                >
                <strong
                  *ngIf="!session.isFeeReady"
                  class="text-sm font-extrabold text-white/40 fee-blur-text"
                  >฿ --</strong
                >
              </div>
            </div>
            <button
              type="button"
              (click)="goToActiveParking()"
              class="w-full py-2.5 rounded-xl bg-(--main-color) text-[#3a3a3a] text-xs font-extrabold active:scale-[0.98] transition-transform border-none cursor-pointer"
              [class.opacity-70]="!session.isFeeReady"
            >
              {{ currentLang === "TH" ? "จ่าย / ใช้ส่วนลด" : "Pay / Redeem" }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- ========== B: แถบยอด EV บาง — โชว์เสมอ ========== -->
    <div
      class="ev-slim flex items-center gap-3 mt-3 mb-4 bg-white rounded-2xl p-3 shadow-sm border border-black/5"
    >
      <div
        class="ev-bolt w-10 h-10 rounded-xl flex-shrink-0 flex items-center justify-center"
      >
        <img
          src="/icons/charge-home-yellow.png"
          alt=""
          class="w-5 h-5 object-contain brightness-0"
        />
      </div>
      <div class="flex-1 min-w-0 text-left">
        <div
          class="text-[10px] font-semibold text-gray-500 flex items-center gap-1.5 flex-wrap"
        >
          <span>{{ currentLang === "TH" ? "ยอดคงเหลือ" : "Balance" }}</span>
          <span
            class="inline-block text-[9px] font-extrabold bg-[#3a3a3a] text-white px-1.5 py-0.5 rounded-full"
          >
            {{ currentLang === "TH" ? "ชาร์จ EV" : "EV charge" }}
          </span>
        </div>
        <div
          class="text-[17px] font-extrabold text-[#3a3a3a] leading-tight mt-0.5"
        >
          {{ homeTopUpData.amount | number: "1.2-2" }}
          <span class="text-[11px] font-semibold text-gray-500">{{
            currentLang === "TH" ? "บาท" : "THB"
          }}</span>
        </div>
        <div class="text-[9px] text-gray-500 font-medium mt-0.5">
          {{
            currentLang === "TH"
              ? "ใช้ได้เฉพาะค่าชาร์จ · ไม่ใช่ค่าจอดรถ"
              : "EV charging only · not parking fees"
          }}
        </div>
      </div>
      <button
        type="button"
        (click)="goToNavigate('/top-up-ev-charger')"
        class="flex-shrink-0 px-3.5 py-2.5 rounded-full bg-[#3a3a3a] text-white text-xs font-bold border-0 cursor-pointer active:scale-95 transition-transform whitespace-nowrap"
      >
        {{ currentLang === "TH" ? "เติม EV ชาร์จ" : "Top Up EV Charge" }}
      </button>
    </div>

    <!-- ========== Quick menus (mock style: circle icons, no cards) ========== -->
    <h3 class="sec-title mt-4 mb-3">
      {{ currentLang === "TH" ? "เมนูด่วน" : "Quick menus" }}
    </h3>
    <nav class="quick-grid">
      <button
        type="button"
        *ngFor="let data of quickServiceList; trackBy: trackById; let i = index"
        [style.--i]="i"
        (click)="onQuickServiceTap(data)"
        class="quick-item animation-slide-icon-menu"
        [class.is-disabled]="data.disable"
      >
        <span class="q-icon" [class.amber]="isEvQuick(data)">
          <span class="q-lock" *ngIf="data.disable">
            <img src="icons/lock_slate_dark.svg" alt="" />
          </span>
          <span
            class="q-badge"
            *ngIf="!data.disable && alertCount(data.alert) > 0"
          >
            <span class="relative flex h-3.5 w-3.5">
              <span
                class="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"
              ></span>
              <span
                class="relative inline-flex rounded-full h-3.5 w-3.5 bg-red-500 text-white text-[8px] font-bold justify-center items-center"
              >
                {{ alertCount(data.alert) }}
              </span>
            </span>
          </span>
          <img
            [src]="data.image"
            [alt]="data.alt"
            class="q-img"
            [class.opacity-50]="data.disable"
          />
        </span>
        <span class="q-label">
          {{ data.nameTH }}
          <small>{{ data.nameEN }}</small>
        </span>
      </button>
    </nav>

    <!-- ========== ลานจอดแนะนำ (published + online) ========== -->
    <div
      class="mt-6 mb-2"
      *ngIf="isSitesLoading || homeParkingSites.length > 0"
    >
      <div class="flex items-center justify-between mb-3">
        <h3 class="sec-title mb-0">
          {{
            currentLang === "TH"
              ? "ลานจอดที่คุณควรรู้"
              : "Parking sites you should know"
          }}
        </h3>
      </div>

      <div
        *ngIf="isSitesLoading"
        class="text-xs text-slate-400 py-4 text-center"
      >
        {{ currentLang === "TH" ? "กำลังโหลดลานจอด..." : "Loading sites..." }}
      </div>

      <div
        *ngIf="!isSitesLoading && homeParkingSites.length > 0"
        class="lot-rail flex gap-3 overflow-x-auto snap-x snap-mandatory pb-1 -mx-4 px-4 custom-scrollbar"
      >
        <button
          type="button"
          *ngFor="let site of homeParkingSites; trackBy: trackBySite"
          (click)="goToParkingSiteDetail(site); $event.stopPropagation()"
          class="lot-card flex-shrink-0 w-[220px] snap-start bg-white rounded-[18px] overflow-hidden shadow-sm border border-black/5 text-left p-0 cursor-pointer active:scale-[0.98] transition-transform relative z-10"
        >
          <div class="h-28 bg-slate-100 relative overflow-hidden">
            <img
              *ngIf="site.coverImage"
              [src]="site.coverImage"
              [alt]="siteTitle(site)"
              class="w-full h-full object-cover"
            />
            <div
              *ngIf="!site.coverImage"
              class="w-full h-full flex items-center justify-center bg-amber-50"
            >
              <img
                src="/icons/marker-home.png"
                alt=""
                class="w-8 h-8 opacity-40"
              />
            </div>
            <span
              *ngIf="site.isOnline"
              class="absolute top-2.5 left-2.5 text-[10px] font-bold px-2 py-0.5 rounded-full bg-emerald-500 text-white"
            >
              {{ currentLang === "TH" ? "เปิดแล้ว" : "Open" }}
            </span>
          </div>
          <div class="p-3">
            <div
              class="text-xs font-extrabold text-[#3a3a3a] leading-snug line-clamp-2"
            >
              {{ siteTitle(site) }}
            </div>
            <p
              *ngIf="siteSummary(site)"
              class="text-[10px] text-gray-500 mt-1 line-clamp-2 font-medium"
            >
              {{ siteSummary(site) }}
            </p>
            <app-site-amenities
              *ngIf="site.amenityCodes.length"
              class="mt-2"
              [codes]="site.amenityCodes"
              [lang]="currentLang"
              variant="icons"
              [max]="4"
            ></app-site-amenities>
            <span
              class="mt-2.5 block w-full text-center rounded-[10px] bg-[#3a3a3a] text-white text-xs font-bold py-2"
            >
              {{ currentLang === "TH" ? "ดู" : "View" }}
            </span>
          </div>
        </button>
      </div>
    </div>

    <!-- ========== ประกาศ / ข่าวสาร ========== -->
    <div class="mt-6 mb-4">
      <div class="flex items-center justify-between mb-4">
        <div class="flex items-center gap-1.5 text-gray-700">
          <img src="icons/notifications_orange.svg" alt="news" />
          <h3 class="text-base font-bold tracking-wide">
            {{ currentLang === "TH" ? "ประกาศ / ข่าวสาร" : "Announcements" }}
          </h3>
        </div>
        <button
          type="button"
          (click)="goToNewsList()"
          class="text-xs font-bold text-amber-500 hover:text-amber-600 bg-transparent border-none cursor-pointer"
        >
          {{ currentLang === "TH" ? "ดูทั้งหมด" : "View All" }}
        </button>
      </div>

      <div
        *ngIf="isNewsLoading"
        class="text-xs text-slate-400 py-6 text-center"
      >
        {{ currentLang === "TH" ? "กำลังโหลดข่าว..." : "Loading news..." }}
      </div>

      <div
        *ngIf="!isNewsLoading && homeNews.length === 0"
        class="bg-white rounded-2xl border border-gray-100 px-4 py-6 text-center text-xs text-slate-400 font-medium"
      >
        {{ currentLang === "TH" ? "ยังไม่มีข่าวสาร" : "No announcements yet" }}
      </div>

      <div
        *ngIf="!isNewsLoading && homeNews.length > 0"
        class="flex space-x-4 overflow-x-auto pb-2 custom-scrollbar snap-x snap-mandatory"
      >
        <button
          type="button"
          *ngFor="let news of homeNews"
          (click)="goToNewsDetail(news.id)"
          class="w-[260px] flex-shrink-0 bg-white rounded-2xl overflow-hidden border border-gray-100 shadow-sm snap-start text-left cursor-pointer hover:shadow-md transition-shadow p-0"
        >
          <div class="w-full h-32 overflow-hidden bg-gray-100 relative">
            <img
              *ngIf="news.coverImageUrl"
              [src]="news.coverImageUrl"
              [alt]="newsTitle(news)"
              class="w-full h-full object-cover"
            />
            <div
              *ngIf="!news.coverImageUrl"
              class="w-full h-full flex items-center justify-center bg-amber-50"
            >
              <img
                src="icons/notifications_orange.svg"
                alt=""
                class="w-8 h-8 opacity-50"
              />
            </div>
            <span
              *ngIf="news.pin"
              class="absolute top-2 left-2 px-2 py-0.5 rounded-lg bg-amber-400/95 text-[10px] font-bold text-slate-900"
            >
              {{ currentLang === "TH" ? "ปักหมุด" : "Pinned" }}
            </span>
          </div>
          <div class="p-3 text-left">
            <h4 class="text-sm font-bold text-gray-800 line-clamp-2">
              {{ newsTitle(news) }}
            </h4>
            <p
              *ngIf="news.summary"
              class="text-xs text-gray-500 mt-1 line-clamp-2"
            >
              {{ news.summary }}
            </p>
            <div class="flex items-center gap-1.5 mt-2 flex-wrap">
              <span
                *ngIf="!news.siteId"
                class="px-1.5 py-0.5 rounded bg-sky-50 text-sky-700 text-[9px] font-bold"
                >City Parking</span
              >
              <span
                *ngIf="news.siteId"
                class="px-1.5 py-0.5 rounded bg-emerald-50 text-emerald-700 text-[9px] font-bold"
                >{{ currentLang === "TH" ? "ประกาศจากลาน" : "From lot"
                }}{{ news.siteName ? " · " + news.siteName : "" }}</span
              >
            </div>
          </div>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- ========== More menu bottom sheet ========== -->
<div
  class="more-backdrop"
  *ngIf="isMoreSheetOpen"
  (click)="closeMoreSheet()"
  aria-hidden="true"
></div>
<div
  class="more-sheet"
  *ngIf="isMoreSheetOpen"
  role="dialog"
  aria-labelledby="more-menu-title"
>
  <div class="more-sheet-head">
    <div class="sheet-handle"></div>
    <div class="more-sheet-head-row">
      <div class="text-left min-w-0">
        <h3 id="more-menu-title" class="more-sheet-title">
          {{ currentLang === "TH" ? "เมนูทั้งหมด" : "All menus" }}
        </h3>
        <p class="more-sheet-sub">
          {{
            currentLang === "TH"
              ? "จัดกลุ่มตามหมวดบริการ"
              : "Grouped by category"
          }}
        </p>
      </div>
      <button
        type="button"
        (click)="closeMoreSheet()"
        class="more-close"
        aria-label="Close"
      >
        <img src="icons/close_slate.svg" alt="" class="more-close-icon" />
      </button>
    </div>
  </div>
  <div class="sheet-body custom-scrollbar">
    <ng-container *ngFor="let category of moreMenuCategories">
      <div class="more-cat">
        <h4 class="more-cat-title">
          {{ currentLang === "TH" ? category.categoryTH : category.categoryEN }}
        </h4>
        <div class="more-grid">
          <button
            type="button"
            *ngFor="let data of category.list"
            (click)="onMoreMenuTap(data)"
            class="quick-item more-item"
            [class.is-disabled]="data.disable"
          >
            <span class="q-icon q-icon-sm" [class.amber]="isEvQuick(data)">
              <span class="q-lock" *ngIf="data.disable">
                <img src="icons/lock_slate_dark.svg" alt="" />
              </span>
              <span
                class="q-badge"
                *ngIf="!data.disable && alertCount(data.alert) > 0"
              >
                <span class="relative flex h-3.5 w-3.5">
                  <span
                    class="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"
                  ></span>
                  <span
                    class="relative inline-flex rounded-full h-3.5 w-3.5 bg-red-500 text-white text-[8px] font-bold justify-center items-center"
                  >
                    {{ alertCount(data.alert) }}
                  </span>
                </span>
              </span>
              <img
                [src]="data.image"
                [alt]="data.alt"
                class="q-img q-img-sm"
                [class.opacity-50]="data.disable"
              />
            </span>
            <span class="q-label more-label">
              {{ currentLang === "TH" ? data.nameTH : data.nameEN }}
            </span>
          </button>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<app-pss-loading *ngIf="isLoading"></app-pss-loading>
<app-pss-success
  *ngIf="isSuccess"
  (close)="isSuccess = $event"
  [timeIn]="3000"
  [text]="textSuccess"
  [detail]="detailSuccess"
></app-pss-success>
